/* eslint-disable @typescript-eslint/no-explicit-any */

import { typeCheck } from "@/lib/type-check";
import { Fragment } from "react/jsx-runtime";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { AuditTableV3 } from "./audit-table-v3";
import { AuditListingItem } from "./audit-listing-item";
import { useMemo } from "react";
import { cn } from "@/lib/utils";

export const AuditListingV2 = ({ data, parentKey }: any) => {
  const getValue = (value: any) => {
    if ("text" in value) {
      return value?.text;
    }

    if (value === null || value?.text === null) {
      return "";
    }
    return value;
  };

  const isArrayExist = useMemo(() => {
    for (const key in data) {
      const currentText = getValue(data[key]);
      const checkType = typeCheck(currentText);
      if (checkType === "Array") {
        return true;
      }
    }
    return false;
  }, [data]);

  return (
    <div className="overflow-x-auto pb-1">
      <div className={cn("w-max min-w-full", { "max-w-full": !isArrayExist })}>
        {Object.entries(data).map(([key, value]: any, index: number) => {
          const currentText = getValue(value);
          const checkType = typeCheck(currentText);
          const currentKey = value?.regions
            ? `${parentKey}.${key}.text`
            : `${parentKey}.${key}`;
          return (
            <Fragment key={key}>
              <ConditionRenderer condition={checkType === "Array"}>
                <>
                  <AuditTableV3
                    data={value}
                    keyValue={key}
                    feedback={value}
                    parentKey={`${parentKey}.${key}`}
                  />
                </>
                <>
                  <AuditListingItem
                    parentKey={currentKey}
                    data={currentText}
                    feedback={value}
                    keyValue={key}
                    isFirstRow={index === 0}
                  />
                </>
              </ConditionRenderer>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
